import { RootState } from '@store/store.interface';

import { TInquiriesListKey } from './slice.interface';

const getState = (state: RootState) => state.inquiries.list;
export const inquiriesListSelector = (key: TInquiriesListKey) => (state: RootState) =>
  getState(state)[key]?.data || [];
export const inquiriesListIsLoadingSelector = (key: TInquiriesListKey) => (state: RootState) =>
  getState(state)[key]?.isLoading || false;
export const inquiriesListErrorSelector = (key: TInquiriesListKey) => (state: RootState) =>
  getState(state)[key]?.error || false;
export const inquiriesListPaginationSelector = (key: TInquiriesListKey) => (state: RootState) =>
  getState(state)[key]?.pagination || { page: 1 };
